import pushAnalytics from './pushAnalytics';

export default function pushLinkAnalytics({
    ctaText,
    href,
    initiator = 'user',
    tree = [],
    user_login_source,
    content_section = 'Sign in',
    user_logged_status = 'Logged Out'
}) {
    pushAnalytics('aa-link', {
        app: 'tcom sign in',
        link_text: ctaText,
        link_href: href,
        link_trigger: 'aa-link',
        initiator,
        content_section,
        user_login_source,
        user_logged_status,
        _tree: tree
    });
}